<button
  mat-button
  color="primary"
  [matMenuTriggerFor]="menu"
  data-cy="add-document-category">
  Add Docs
</button>
<mat-menu
  #menu="matMenu"
  class="doc-category-menu">
  <button
    data-cy="add-document-category-option"
    *ngFor="let documentCategory of documentCategories"
    mat-menu-item
    (click)="addCategory(documentCategory)">
    {{ documentCategory.name }}
  </button>
</mat-menu>
